module.exports = __webpack_public_path__ + "img/topc3.50173b1f.png";